/*
 * Imports Vue, creates and exports a new instance of Vue.
 * EventBus makes it possible to emit an event in one component
 * and listen for that event in another.
 *
 * @fileOverview exports a new instance of Vue
 */

import Vue from 'vue';

const EventBus = new Vue();

export default EventBus;
